<template>
  <input
    class="apple-ui-text-field"
    :type="type"
    :value="value"
    :disabled="disabled"
    v-bind="$attrs"
    v-on="forwardedListeners"
    @input="$emit('input', $event.target.value)"
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  name: 'AppleTextField',
  inheritAttrs: false,
  props: {
    value: { type: String, default: '' },
    type: { type: String, default: 'text' },
    disabled: Boolean,
  },
  computed: {
    forwardedListeners() {
      const listeners = { ...this.$listeners };
      delete listeners.input;
      delete listeners.change;
      return listeners;
    },
  },
};
</script>

<style scoped>
.apple-ui-text-field {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  min-height: var(--apple-ui-control-height, 32px);
  padding: 6px 10px;
  border: 1px solid var(--apple-ui-border, var(--apple-border));
  border-radius: var(--apple-ui-radius-control, 7px);
  background: var(--apple-ui-surface-raised, var(--color-secondary-bg));
  color: var(--apple-ui-text, var(--color-text));
  font: inherit;
  font-size: 13px;
  line-height: 1.35;
}
.apple-ui-text-field::placeholder { color: var(--apple-ui-muted, var(--color-secondary)); opacity: .82; }
.apple-ui-text-field:hover:not(:disabled) { border-color: color-mix(in srgb, var(--apple-ui-text, var(--color-text)) 30%, transparent); }
.apple-ui-text-field:focus { outline: none; }
.apple-ui-text-field:focus-visible { border-color: var(--apple-ui-accent, var(--color-primary)); box-shadow: inset 0 0 0 1px var(--apple-ui-accent, var(--color-primary)); }
.apple-ui-text-field:disabled { opacity: .45; cursor: default; }
</style>
